import { useTranslation } from 'react-i18next';

import { TileActionText } from './TileActionText.jsx';
import { CloseButton } from './TileActionButtons.jsx';

import { LeftButton, RightButton } from './StyledComponents';

export const PreviewFormMenu = ({
  goToEdit,
  campaignContainer,
  postId,
  tileStatus,
  publishDate,
  onClose,
  uuid,
}) => {
  const { t } = useTranslation('tileForm');

  return (
    <>
      <LeftButton mode="outline" variant="black" onClick={onClose}>
        <CloseButton />
      </LeftButton>
      <TileActionText
        publishDate={publishDate}
        tileStatus={tileStatus}
        postId={postId}
        campaignContainer={campaignContainer}
        uuid={uuid}
      />

      <RightButton mode="contained" onClick={goToEdit} variant="primary">
        <i className="fa-light fa-pen fa-lg"></i>
        {t('tileActionMenu.edit')}
      </RightButton>
    </>
  );
};
